import { createPrng } from '@play-co/replicant';
import { PlayButtonOptions } from '.';
import { MutableState } from '../State';
import { getRandomItemFromArray } from '../utils/random';
import { chatbotStaticAssets } from './chatbotStaticAssets';
import { Care } from '../buruburu/care';

export function getConversationalImageId(
  species: string,
  type: string,
  seed?: string | number,
) {
  const random = seed ? createPrng(String(seed)) : Math.random;
  const version = getRandomItemFromArray(['v01'], random);
  const id = `static/conversational/${species}/${version}/${type}`;
  if (!chatbotStaticAssets[id]) throw new Error('Invalid image id: ' + id);
  return id;
}

export async function processQuickReplyAction(
  state: MutableState,
  api,
  opts: PlayButtonOptions,
): Promise<PlayButtonOptions> {
  const action = opts?.action;
  if (!action) return opts;

  if (action === 'pay-food-40') {
    if (state.inventory.points < 40) {
      const species = opts?.species || 'ball';
      opts.messageText = 'Not enough coins!\nCome play a minigame!';
      opts.imageUrl = getConversationalImageId(species, 'coins');
    } else {
      Care.modifiers(state).purchaseCareItem(state, 'f_buruburuFood_b', api);
    }
    return opts;
  }

  if (action === 'pay-food-60') {
    if (state.inventory.points < 60) {
      const species = opts?.species || 'ball';
      opts.messageText = 'Not enough coins!\nCome play a minigame!';
      opts.imageUrl = getConversationalImageId(species, 'coins');
    } else {
      Care.modifiers(state).purchaseCareItem(state, 'f_gentleSushi_b', api);
    }
    return opts;
  }

  return opts;
}
